module.exports = __webpack_public_path__ + "static/hepburn-613979f8cdcb94d5ebd3c61718f24fed.jpg";